export class snippetsUtils {
    static async sortByHighestWeight(snippets) {
        // sort snippets by weight highest first
        return await snippets.sort((a, b) => {
            return b.weight - a.weight;
        });
    }
    static async sortByLowestWeight(snippets) {
        // sort snippets by weight lowest first
        return await snippets.sort((a, b) => {
            return a.weight - b.weight;
        });
    }
    static async sortByNewest(snippets) {
        // sort snippets by newest first
        return await snippets.sort((a, b) => {
            return b.createdOn - a.createdOn;
        });
    }
    static async sortByOldest(snippets) {
        // sort snippets by oldest first
        return await snippets.sort((a, b) => {
            return a.createdOn - b.createdAt;
        });
    }
    static sortByArchived(snippets) {
        return snippets.sort((a, b) => Number(a.archived) - Number(b.archived));
    }
    static isSnippetDroppable(elementTarget, draggingSnippetId) {
        const placeholderTarget = elementTarget;
        // split placeholderId by $cw$ to get snippet id's
        const placeholderIds = placeholderTarget.id.split("$cw$");
        // if snippetId is any of the placeholder id's, then return
        // else expand placeholderTarget
        if (placeholderIds.includes(draggingSnippetId))
            return false;
        else
            return true;
    }
    static async separatorDragEnter(event, draggingSnippetId, isExtension) {
        // block drag-drop in beginning
        event.dataTransfer.dropEffect = "none";
        const separator = event.target;
        if (this.isSnippetDroppable(separator, draggingSnippetId)) {
            // set drag-drop effect to move
            event.dataTransfer.dropEffect = "move";
            // if we are using extension
            if (isExtension) {
                separator.style.minHeight = "10rem";
                separator.style.height = "10rem";
            }
            else {
                // check if we are in mobile or desktop and set min height or min width
                if (window.innerWidth < 768) {
                    separator.style.minHeight = "10rem";
                    separator.style.height = "10rem";
                }
                else {
                    separator.style.minWidth = "16rem";
                    separator.style.width = "16rem";
                }
            }
            separator.classList.add("cw-invisible-separator--expanded");
        }
    }
    static async separatorDragLeave(separator, isExtension) {
        // if we are using extension
        if (isExtension) {
            separator.style.minHeight = "1.5rem";
            separator.style.height = "1.5rem";
        }
        else {
            // check if we are in mobile or desktop and reset min height or min width
            if (window.innerWidth < 768) {
                separator.style.minHeight = "1.5rem";
                separator.style.height = "1.5rem";
            }
            else {
                separator.style.minWidth = "1.5rem";
                separator.style.width = "1.5rem";
            }
        }
        separator.classList.remove("cw-invisible-separator--expanded");
    }
    static async separatorDrop(separator, snippets, snippetId, updateSnippet, isExtension) {
        // find snippet by id
        const snippet = snippets.find((snippet) => snippet.id === snippetId);
        if (this.isSnippetDroppable(separator, snippet.id)) {
            // if we are using extension
            if (isExtension) {
                separator.style.minHeight = "1.5rem";
                separator.style.height = "1.5rem";
            }
            else {
                // FIXME: Whenever there's "reset" a "reset()" should be called
                // check if we are in mobile or desktop and reset min height or min width
                if (window.innerWidth < 768) {
                    separator.style.minHeight = "1.5rem";
                    separator.style.height = "1.5rem";
                }
                else {
                    separator.style.minWidth = "1.5rem";
                    separator.style.width = "1.5rem";
                }
            }
            separator.classList.remove("cw-invisible-separator--expanded");
            // update snippet weight
            let updatedSnippet = {
                id: snippet.id,
                weight: Number(separator === null || separator === void 0 ? void 0 : separator.getAttribute("data-weight")),
            };
            updateSnippet(updatedSnippet);
            // sort snippets by highest weight and update active topic store
            this.sortByHighestWeight(snippets);
        }
    }
}
